/**
 * First-challenge tour seen-flag. DISTINCT from questionnaire-seen so a returning guest lands in the
 * Arena without re-entering the tour. Mirrors walkthroughSeenStorage (web localStorage, native
 * AsyncStorage), keyed per user. See specs/first-challenge-onboarding/spec.md (AC-11).
 */

import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { logger } from '../../helpers/logger.helper';
import { FIRST_CHALLENGE_TOUR_SEEN_KEY } from '../constants/firstChallengeTour.constants';

const seenKey = (userId: string) => `${FIRST_CHALLENGE_TOUR_SEEN_KEY}_${userId}`;

export async function hasSeenFirstChallengeTour(userId: string): Promise<boolean> {
  const storageKey = seenKey(userId);
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      return localStorage.getItem(storageKey) === 'true';
    }
    return (await AsyncStorage.getItem(storageKey)) === 'true';
  } catch (error) {
    if (__DEV__) logger.warn('firstChallengeTourSeen: read failed', { storageKey, error });
    return false;
  }
}

export async function markFirstChallengeTourSeen(userId: string): Promise<void> {
  const storageKey = seenKey(userId);
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      localStorage.setItem(storageKey, 'true');
      return;
    }
    await AsyncStorage.setItem(storageKey, 'true');
  } catch (error) {
    if (__DEV__) logger.warn('firstChallengeTourSeen: write failed', { storageKey, error });
  }
}
